import React, { useEffect, useState } from "react";

import axios from "axios";
import STAYardMaster from "./STAYardMaster";
import STATrafficFlowMaster from "./STATrafficFlowMaster";
import STAYardPDDMaster from "./STAYardPDDMaster";

const STAYard = () => {
  const [active, setActive] = useState("STA YARD EX");

  return (
    <div style={{ minHeight: "90vh" }} className="papaDiv">
      <div className="row ">
        <div className="d-flex justify-content-center m-2">
          <button
            onClick={() => {
              setActive("STA YARD EX");
            }}
            className={`btn btn-sm btn-outline-dark me-1 ${
              active === "STA YARD EX" && "active"
            }`}
          >
            STA YARD EX
          </button>
          <button
            onClick={() => {
              setActive("STA YARD TRAFFIC FLOW");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "STA YARD TRAFFIC FLOW" && "active"
            }`}
          >
            STA YARD TRAFFIC FLOW
          </button>

          <hr />
          <button
            onClick={() => {
              setActive("STA YARD PDD");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "STA YARD PDD" && "active"
            }`}
          >
            STA YARD PDD
          </button>
        </div>
      </div>
      <div className="row">
        {active === "STA YARD EX" ? (
          <div className="">
            <STAYardMaster />
          </div>
        ) : active === "STA YARD TRAFFIC FLOW" ? (
          <div>
            <STATrafficFlowMaster />
          </div>
        ) : (
          <div>
            <STAYardPDDMaster />
          </div>
        )}
      </div>
    </div>
  );
};
export default STAYard;
